import { Dropdown, Menu } from "antd";
import React, { useState } from "react";
import arrow from "../../../assets/svgs/header-icon/arrow-down.svg";
import arrowGrey from "../../../assets/svgs/header-icon/arrow-down-grey.svg";
import { KYC_Tier } from "../FilterItems/FilterItems";
import SpMenu from "../../SpMenu/SpMenu";

const KycTier = ({onChange}) => {
  const [method, setMethod] = useState("Search bills");
  const [selected, setSelected] = useState(false);

  function handleFilterSelect({item, index}) {
    setMethod(item?.method?? 'All');

    setSelected(true);

    if (typeof onChange === "function") {
      onChange(item?.method?? '');
    }
  }

  const menu = (
    <SpMenu items={KYC_Tier} renderItem={(item) => <p>{item.method}</p>} onSelect={handleFilterSelect} />
  );


  return (
    <div className="filter-modal-inner">
      <p>KYC Tier</p>
      <Dropdown overlay={menu} trigger={["click"]}>
        <button
          className={
            selected ? "selected filter-modal-btn" : "filter-modal-btn"
          }
        >
          {" "}
          {method}
          <span className="filter-icon">
            {selected ? (
              <img src={arrow} alt="/" />
            ) : (
              <img src={arrowGrey} alt="/" />
            )}
          </span>{" "}
        </button>
      </Dropdown>
    </div>
  );
};

export default KycTier;
